export default {
  title: '我们为您提供专业的软硬件服务',
  detail: ("坐落于中国创新之都深圳，深圳市风响树科技有限公司自2014年成立以来，始终专注于为客户提供全面的软硬件服务与定制化解决方案。我们的核心团队由经验丰富的行业专家和技术精英组成，他们凭借对市场的深刻理解和卓越的技术实力，致力于将创新思维融入每一个项目中。公司坚持“技术领先、服务卓越”的发展理念，通过不断的技术创新和优化服务流程，已经成功服务于金融、医疗、教育和零售等多个行业，帮助客户实现业务流程的革新和运营效率的显著提升。我们的服务不仅限于传统的IT支持，更拓展到了智能硬件开发、移动应用开发，以及基于云平台的系统架构设计等领域。在技术研发方面，风响树科技持续投入，拥有一系列自主知识产权的软件产品和专利技术。我们注重技术的实用性与前瞻性，致力于将最前沿的科技成果转化为推动客户业务发展的强大动力。此外，公司积极与国内外知名企业建立合作关系，通过技术交流和资源共享，不断提升自身的核心竞争力。展望未来，风响树科技将继续坚持以客户为中心的服务宗旨，不断优化服务流程，提升服务质量。我们以开放的心态迎接全球化挑战，致力于成为国内外客户信赖的IT服务伙伴。我们坚信，通过不断的努力和创新，风响树科技将与客户共同开启数字化转型的新篇章，共创辉煌。\
  <p><a href=\"mailto:sales@maxgiftexporter.com?subject=I have a Enquery\"><font color=#66addf>联系我们</font></a> 获得你想要的服务！ ")
}



// WEBPACK FOOTER //
// ./src/pages/home/components/who_we_are/config.js